import { jsx as _jsx } from "react/jsx-runtime";
import merge from 'lodash/merge';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from '../../../foundation/theme/theme';
// Component.
// -----------------------------------------------------------------------------
const UIProvider = ({ theme = {}, children }) => (_jsx(ThemeProvider, { theme: merge(defaultTheme, theme), children: children }));
export default UIProvider;
//# sourceMappingURL=UIProvider.js.map